import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

interface Props {
  label: string;
}

const AiModeBadge = ({ label }: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <span style={styles.badge}>
      <span>{label}</span>
    </span>
  );
};

const getStyles = (theme: AITTheme) => ({
  badge: {
    backgroundColor: '#e6f4fb',
    color: theme.linkColor,
    padding: '6px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    border: `1px solid ${theme.linkColor}`
  }
});

export default AiModeBadge;
